import encryptedMap from '../constants/encrypted-map';

const encryptString = (str) => [...str].map((char) => encryptedMap[char] || char).join('');

export default encryptString;
